module.exports = __webpack_public_path__ + "img/openChat.78363f4b.png";